import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLocation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLocation"><Path fillRule="evenodd" clipRule="evenodd" d="M6.19009 6.19107L22.455 1.54395L17.8079 17.8089L1.54297 22.456L6.19009 6.19107ZM9.49899 12C9.49899 10.6193 10.6183 9.5 11.999 9.5C13.3797 9.5 14.499 10.6193 14.499 12C14.499 13.3807 13.3797 14.5 11.999 14.5C10.6183 14.5 9.49899 13.3807 9.49899 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLocation;
